import React from "react";

const DefaultComponent = ({component}) => (
    <div className="d-flex flex-column container">
        <div className="d-flex justify-content-between mt-4">
            <h3 className="mb-3 home_carousels_title">{component?.name}</h3>
            {component?.type?.name}
        </div>
        <ul className="list-group">
            {component.data && component.data.length !== 0
                ? component.data.map(item => <li className="list-group-item">{item.title || item.name}</li>)
                : null}
        </ul>
    </div>
);

export default DefaultComponent;
